export default "__VITE_ASSET__592526ca__"